<template>
<div class="large-container">
	<Form :label-width="110">
		<Row>
			<Col span="24">
				<b>延保履约服务</b>&nbsp;&nbsp;&nbsp;<Button type="info" @click="showWangdian()">绑定网点</Button>
			</Col>
		</Row>
		<Row :gutter="10" class="mt20">
			<Col span="6">
				<FormItem label="审核状态">
					<Select v-model="params.auditStatus" placeholder="请选择审核状态" clearable>
						<Option value="WAITING">待审核</Option>
						<Option value="PASS">审核通过</Option>
						<Option value="REJECT">审核驳回</Option>
					</Select>
				</FormItem>
			</Col>
			<Col span="6">
				<FormItem label="理赔状态">
					<Select v-model="params.claimsStatus" placeholder="请选择理赔状态" clearable>
						<Option value="NORMAL">正常</Option>
						<Option value="REJECT">拒赔</Option>
						<Option value="OVERFLOW">溢出</Option>
					</Select>
				</FormItem>
			</Col>
			<Col span="6">
				<FormItem label="支付状态">
					<Select v-model="params.paymentStatus" placeholder="请选择支付状态" clearable>
						<Option value="UN_PAID">待支付</Option>
						<Option value="PAID">已支付</Option>
					</Select>
				</FormItem>
			</Col>
			<Col span="6">
				<FormItem label="工单号">
					<Input v-model="params.workOrderNo" clearable @on-enter="search" placeholder="请输入工单号"></Input>
				</FormItem>
			</Col>
			<Col span="6">
				<FormItem label="提交状态">
					<Select v-model="params.submitStatus" placeholder="请选择提交状态" clearable>
						<Option value="SUBMITTED">已提交</Option>
						<Option value="UN_SUBMITTED">未提交</Option>
					</Select>
				</FormItem>
			</Col>
			<Col span="6">
				<FormItem label="支付时间">
					<daterange @on-change="val=>{setDateRange(val,'paymentTime')}" is-fulltime transfer
                            placeholder="请选择支付时间"></daterange>
				</FormItem>
			</Col>
			<Col span="24" class="right">
				<Button type="info" @click="search">搜索</Button>
				<!-- <Button type="primary" @click="excel">导出</Button> -->
			</Col>
		</Row>
	</Form>
	<i-table class="mt10" :columns="columns" url="/yanbao/agreement/queryWorkOrderList.json" 
		:params="params" ref="table" 
		:count="10" 
		:handle-data="handleData"
		 @on-selection-change="selectChange">
		<template slot-scope="{ row, index }" slot="materialUrl">
			<a :href="row.materialUrl" v-if="row.materialUrl" target="_blank">查看</a>
		</template>
		<template slot-scope="{ row, index }" slot="action">
			<a @click="showRepairOrder(row)">下载电子维修单</a>
			<a v-if="(row.auditStatus=='REJECT'||!row.auditStatus)&&row.claimsStatus!='OVERFLOW'"
				@click="openUpload(row)" 
				>
				提交资料
			</a>
		</template>
	</i-table>
	<Modal v-model="editShow" title="上传加盖公章的维修单" :mask-closable="false" @on-visible-change="handleReset('editForm')">
		<Form :label-width="110" :model="editForm" ref="editForm">
			<Form-item label="" >
				<UploadFileImg :accept="['image','PDF']" @on-success="uploadSuccess" type="select" btn-text="上传"/> 
				<a @click="openOriginFile(editForm.attachmentUrl)" v-show="editForm.attachmentUrl" class="ml15">查看</a>
			</Form-item>
		</Form>
		<div slot="footer">
			<Button @click="editShow = false" type="default">取消</Button>
			<Button @click="confirmUpload" :disabled="Boolean(!editForm.attachmentUrl)" type="primary">确定</Button>
		</div>
	</Modal>
	<Modal v-model="wangdian.show" title="新增网点" :mask-closable="false" @on-visible-change="handleReset('wangdianForm')" >
		<Form :label-width="110" :model="wangdian.form" ref="wangdianForm">
			<Form-item label="HR码" :rules="{required: true,  message: '请输入HR码', trigger: 'blur'}" prop="hrCode">
				<Input v-model="wangdian.form.hrCode" placeholder="请输入HR码" clearable />
			</Form-item>
			<Form-item label="网点地址" :rules="{required: true,  message: '请输入网点地址', trigger: 'blur'}" prop="companyAddress">
				<Input v-model="wangdian.form.companyAddress" placeholder="请输入网点地址" clearable />
			</Form-item>
			<Form-item label="网点电话" :rules="{required: true,  message: '请输入网点电话', trigger: 'blur',pattern:rules.telOrPhone}" prop="companyPhone">
				<Input v-model="wangdian.form.companyPhone" placeholder="请输入网点电话" clearable />
			</Form-item>
		</Form>
		<div slot="footer">
			<Button @click="wangdian.show = false" type="default">取消</Button>
			<Button @click="bindWangdian()" type="primary">确定</Button>
		</div>
	</Modal>
	<Modal v-model="repairOrder.show" title="下载电子维修单" :mask-closable="false" @on-visible-change="handleReset('repairOrderForm')" >
		<Form :label-width="110" :model="repairOrder.form" ref="repairOrderForm">
			<Form-item label="顾客姓名" :rules="{required: true,  message: '请输入顾客姓名', trigger: 'blur'}" prop="customerName">
				<Input v-model="repairOrder.form.customerName" :maxlength="15" placeholder="请输入顾客姓名" clearable />
			</Form-item>
			<Form-item label="顾客电话" :rules="{required: true,  message: '请输入顾客电话', trigger: 'blur',pattern:rules.telOrPhone}" prop="customerPhone">
				<Input v-model="repairOrder.form.customerPhone" :maxlength="15" placeholder="请输入顾客电话" clearable />
			</Form-item>
			<Form-item label="顾客地址" :rules="{required: true,  message: '请输入顾客地址', trigger: 'blur'}" prop="customerAddress">
				<Input @keyup.native="btKeyUp" @keydown.native="btKeyDown" v-model="repairOrder.form.customerAddress" :maxlength="120" placeholder="请输入顾客地址" clearable />
			</Form-item>
			<p>下载电子工单后，打印并加盖公章，然后扫描或拍照上传</p>
		</Form>
		<div slot="footer">
			<Button @click="repairOrder.show = false" type="default">取消</Button>
			<Button @click="bindRepairOrder()" type="primary">确定</Button>
		</div>
	</Modal>
</div>
</template>
<script>
import ITable from '@/components/common/ITable'
import daterange from '@/components/common/daterange'
import UploadFileImg from '@/components/common/UploadFileImg'
import { mapState } from 'vuex'
export default {
	components:{daterange,ITable,UploadFileImg},
	data () {
		return {
			params:{},
			wangdian:{
				show:false,
				form:{}
			},
			repairOrder:{
				show:false,
				form:{}
			},
			columns:[
				{type: 'index',width: 65,align: 'center',fixed:'left',title:'序号'},
				{title: '所属工贸',key: 'trade',minWidth:140},
				{title: '工单编号',key: 'workOrderNo',minWidth:200},
				{title: '网点代码',key: 'hrCode',width:140},
				{title: '网点名称',key: 'companyName',width:160},
				{title: '商品名称',key: 'goodsName',width:140},
				{title: '产品型号',key: 'productModel',width:120},
				{title: '服务方式',key: 'serviceMode',width:180},
				{title: '服务措施描述',key: 'serviceMeasure',width:180},
				{title: '部件',key: 'component',width:140},
				{title: '故障原因描述',key: 'faultCause',width:180},
				{title: '顾客姓名',key: 'customerName',width:120},
				{title: '产品序列号',key: 'productSerialNo',width:120},
				{title: '人工费用',key: 'laborCost',width:120},
				{title: '运输费用',key: 'transportCost',width:120},
				{title: '备件费',key: 'partsCost',width:120},
				{title: '共计',key: 'totalCost',width:120},
				{title: '海尔结单时间',key: 'recordTime',width:180,sortable: true},
				{title: '延期保修卡号',key: 'warrantyCardNo',width:200},
				{title: '延保公司',key: 'insuranceCompanyName',width:120},
				{title: '理赔状态',key: 'claimsStatusShow',width:120},
				{title: '溢出原因',key: 'overflowCause',width:180},
				{title: '资料提交状态',key: 'materialSubmitStatusShow',width:130},
				{title: '提交资料',slot:'materialUrl',key: 'materialUrl',width:120},
				{title: '提交时间',key: 'materialSubmitTime',width:180,sortable: true},
				{title: '审核状态',key: 'auditStatusShow',width:120},
				{title: '驳回原因',key: 'auditRejectCause',width:180},
				{title: '支付状态',key: 'paymentStatusShow',width:120},
				{title: '支付时间',key: 'paymentTime',width:180},
				{title: '操作',slot: 'action',width:140,fixed:'right'},
			],
			editForm:{},
			editShow:false,
			handleData:res=>{
				return res.map(item=>{
					return {
						...item,
						_disabled:item.status=='OK_DONE'
					}
				})
			},
			selectedList:[],
			modalTitle:''
		}
	},
	computed:{
		...mapState({
			userInfo:state=>state.common.info
		})
	},
	watch:{
		userInfo(){
			this.checkLogin()
		},
	},
	created () {
		this.checkLogin()
	},
	methods: {
		setDateRange (val, key) {
			this.params[key + 'Start'] = val[0];
			this.params[key + 'End'] = val[1];
		},
		getTimeInterval(time) { //time为特定时间
			var someDate = new Date(time);
			// 获取当前时间
			var currentDate = new Date();
			// 计算时间差，单位为天
			var differenceInDays = (currentDate - someDate) / (1000 * 60 * 60 * 24);
			// 判断时间差是否小于731天
			if (differenceInDays < 731) {
				return true
			} else {
				this.$message.error('此单的海尔结单时间超出提交规定时长，无法提交')
				return false
			}
		},
		btKeyDown(e) {
			e.target.value = e.target.value.replace(/[^\a-\z\A-\Z0-9\u4E00-\u9FA5]/g,"");
		},
		//限制输入特殊字符
		btKeyUp(e) {
			e.target.value = e.target.value.replace(/[`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘’，。、]/g,"");
		},
		showWangdian () {
			this.wangdian.form = {}
			this.wangdian.show = true
		},
		showRepairOrder (row) {
			this.repairOrder.form = {}
			this.repairOrder.form.id = row.id
			this.repairOrder.show = true
		},
		async bindWangdian () {
			let vaild = await this.$refs.wangdianForm.validate()
			if (vaild) {
				await this.$axios.post('/yanbao/agreement/bindCompanyUser.json',this.wangdian.form)
				this.$refs.wangdianForm.resetFields()
				this.wangdian.form = {}
				this.search()
				this.wangdian.show=false;
				this.toast('操作成功')
			}
		},
		async bindRepairOrder () {
			let vaild = await this.$refs.repairOrderForm.validate()
			if (vaild) {
				this.exportToExcel("/yanbao/agreement/exportWorkOrder",this.repairOrder.form);
				this.$refs.repairOrderForm.resetFields()
				this.repairOrder.form = {}
				this.search()
				this.repairOrder.show=false;
				this.toast('操作成功')
			}
		},
		search () {
			this.$refs.table.getList();
		},
		excel () {
			this.exportToExcel("/yanbao/agreement/exportWorkOrder",this.params);
		},
		// 打开上传结算单
		openUpload(row){
			if(this.getTimeInterval(row.recordTime)){
				this.editForm = {}
				this.editForm.id=row.id
				this.editShow=true;
			}
		},
		// 确定上传
		confirmUpload(){
			this.$axios.post('/yanbao/agreement/uploadMaintenanceOrder.json',{
				id:this.editForm.id,
				workOrderUrl:this.editForm.attachmentUrl
			}).then(res=>{
				this.search()
				this.editShow=false;
				this.toast('操作成功')
			});
		},
		uploadSuccess(val){
			this.$set(this.editForm,'attachmentUrl',val.url)
		},
		selectChange(val){
			this.selectedList=val
		},
		checkLogin(){
			// 检测登录
			if(!this.userInfo.userId){
				if(location.href&&location.href.indexOf('/common.html#/login')==-1){
					window.location = location.origin +'/common.html#/login?bankUrl='+encodeURIComponent(location.href);
				}
				return false
			}else{
				return true
			}
		},
		handleReset (name) {
			this.$refs[name].resetFields()
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/pages/haierProduct/components/yanbao/Index.vue